module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar4-event-80235e21.svg";